import(/* webpackMode: "eager" */ "/codebuild/output/src3648064673/src/git-codecommit.ap-southeast-2.amazonaws.com/v1/repos/ai-assist-ui/app/login/page.tsx");
